// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1O33x","amount":"Amount_amount__1w3Mb","tip":"Amount_tip__3c_Ca","tipHeader":"Amount_tipHeader__2dN9R","tipsWrap":"Amount_tipsWrap__3mV_b"};